import { z } from 'zod';
import { type SexSchema, sexSchema } from '../const/sexSchema';

export const getAllCategorySchema = z.custom<[SexSchema] | [SexSchema, null] | [SexSchema, string]>(data => {
    return (
        Array.isArray(data) &&
        sexSchema.safeParse(data[0]).success &&
        (typeof data[1] === 'string' || typeof data[1] === 'undefined' || data[1] === null)
    );
});

export type GetAllCategorySchema = z.infer<typeof getAllCategorySchema>;
